(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hears-reponsibility"] && !Shopify.designMode) return;
  try {
    
  addEventListener("DOMContentLoaded",()=>{
    const responsibilitySwipers= Array.from(document.querySelectorAll(".hears-reponsibility-section-swiper"));
    responsibilitySwipers.forEach(swiperEl=>{
      const swiper= new Swiper(swiperEl,{
        spaceBetween: 16
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-text-overlay_timer"] && !Shopify.designMode) return;
  try {
    
  console.log('test')
  function countdownTemplateSetup(countdownTarget){
    let countdownEl= countdownTarget;
    const target= countdownTarget.dataset.target;
    if(target){
      countdownEl= document.querySelector(target);
    }
    const templateContent = document.querySelector(countdownTarget.dataset.template_id).content;
    countdownEl.insertAdjacentElement('afterend',templateContent.firstElementChild);
    return countdownEl;
  }
  function countdownInit(countdownEl,countdownTarget){
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24,
      wrapper = document.querySelector(`#shopify-section-${countdownTarget.dataset.section_id} ${countdownTarget.id ? "#".concat(countdownTarget.id) : ".".concat(countdownTarget.classList.join(","))}+.countdown-timer-template-content`),
      timerDiv = wrapper.querySelector(".countdown-timer");

    const currentTime= new Date();
    const shouldDailyReset= timerDiv.dataset.daily_reset.toLowerCase() === "true" ? true : false;
    const targetYear= shouldDailyReset ? currentTime.getYear() + 1900 : parseInt(timerDiv.dataset.year,10);
    const targetMonth= shouldDailyReset ? currentTime.getMonth() : parseInt(timerDiv.dataset.month, 10) - 1;
    const targetDay= shouldDailyReset ? currentTime.getDate() + 1 : parseInt(timerDiv.dataset.day, 10);
    const targetHour= shouldDailyReset ? 0 : parseInt(timerDiv.dataset.hour, 10);
    const targetMinute= shouldDailyReset ? 0 : parseInt(timerDiv.dataset.minute, 10);

    const targetDate = new Date(
      Date.UTC(
        targetYear,
        targetMonth,
        targetDay,
        targetHour,
        targetMinute,
        0
      )
    );

    console.log(targetDate)

    const countDown = targetDate.getTime();
    const interval = setInterval(function () {
      let now = Date.now(),
        distance = countDown - now,
        days = Math.floor(distance / day),
        hours = Math.floor((distance % day) / hour),
        minutes = Math.floor((distance % hour) / minute),
        seconds = Math.floor((distance % minute) / second);

      (wrapper.querySelector('.js-timer-days').innerText =
        (days < 10 ? '0' : '') + days),
        (wrapper.querySelector('.js-timer-hours').innerText = (
          '0' + hours
        ).slice(-2)
        ),
        (wrapper.querySelector('.js-timer-minutes').innerText = (
          '0' + minutes
        ).slice(-2)),
        (wrapper.querySelector('.js-timer-seconds').innerText = (
          '0' + seconds
        ).slice(-2));

      if (distance < 0) {
        wrapper.querySelector('.js-timer-days').innerText = '00';
        wrapper.querySelector('.js-timer-hours').innerText = '00';
        wrapper.querySelector('.js-timer-minutes').innerText = '00';
        wrapper.querySelector('.js-timer-seconds').innerText = '00';
        wrapper.style.display = 'none';
        clearInterval(interval);
      }
    }, second);

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.detail.sectionId === countdownTarget.dataset.section_id) clearInterval(interval);
    });
  }
  const countdownTargets= document.querySelectorAll(".countdown-target");
  countdownTargets.forEach(countdownTarget=>{
    window.addEventListener("DOMContentLoaded",()=>{
      const countdownEl= countdownTemplateSetup(countdownTarget);
      countdownInit(countdownEl,countdownTarget);
      //Close Button Functionality
      const button= countdownTarget.querySelector(".close-button");
      if(button != undefined){
        button.addEventListener("click",()=>{
          countdownEl.querySelector(".countdown-banner-wrapper").style.display = "none";
        })
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maysa-will-upgrade"] && !Shopify.designMode) return;
  try {
    
  addEventListener("DOMContentLoaded",()=>{
    if(!(window.Shopify && window.Shopify.designMode)){
      gsap.registerPlugin(ScrollTrigger);
  
      const points= Array.from(document.querySelectorAll(".will-upgrade-section-point"));
      // const initialStart=
  
      for(let point of points){
        let height= point.offsetHeight;
        console.log(height);
  
        const triggerConfig= {
          trigger: point,
          start: "top 70%",
          end: ()=>`bottom 70%`,
          // markers: true
        };
  
        gsap.to(point,
          {
            "--point-bar-color": point.dataset.bar,
            duration: 0.5,
            scrollTrigger: {...triggerConfig,toggleActions: "play none none reverse"}
          }
        )
        gsap.from(point,{
          height: 80,
          duration: 1,
          scrollTrigger: {...triggerConfig,scrub: 0.4}
        })
      }
    }else{
      const points= Array.from(document.querySelectorAll(".will-upgrade-section-point"));
      points.forEach(point=>{
        point.style.setProperty("--point-bar-color",point.dataset.bar)
      })
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-countdown"] && !Shopify.designMode) return;
  try {
    
  function countdownTemplateSetup(countdownTarget){
    let countdownEl= countdownTarget;
    const target= countdownTarget.dataset.target;
    if(target){
      countdownEl= document.querySelector(target);
    }
    const templateContent = document.querySelector(countdownTarget.dataset.template_id).content;
    countdownEl.insertAdjacentElement('afterend',templateContent.firstElementChild);
    return countdownEl;
  }
  function countdownInit(countdownEl,countdownTarget){
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24,
      wrapper = document.querySelector(`#shopify-section-${countdownTarget.dataset.section_id} ${countdownTarget.id ? "#".concat(countdownTarget.id) : ".".concat(countdownTarget.classList.join(","))}+.countdown-timer-template-content`),
      timerDiv = wrapper.querySelector(".countdown-timer");

    const currentTime= new Date();
    const shouldDailyReset= timerDiv.dataset.daily_reset.toLowerCase() === "true" ? true : false;
    const targetYear= shouldDailyReset ? currentTime.getYear() + 1900 : parseInt(timerDiv.dataset.year,10);
    const targetMonth= shouldDailyReset ? currentTime.getMonth() : parseInt(timerDiv.dataset.month, 10) - 1;
    const targetDay= shouldDailyReset ? currentTime.getDate() + 1 : parseInt(timerDiv.dataset.day, 10);
    const targetHour= shouldDailyReset ? 0 : parseInt(timerDiv.dataset.hour, 10);
    const targetMinute= shouldDailyReset ? 0 : parseInt(timerDiv.dataset.minute, 10);

    const targetDate = 
      shouldDailyReset 
      ? new Date(targetYear,targetMonth,targetDay,targetHour,targetMinute,0) 
      : new Date(Date.UTC(targetYear,targetMonth,targetDay,targetHour,targetMinute,0));

    const countDown = targetDate.getTime();
    const interval = setInterval(function () {
      let now = Date.now(),
        distance = countDown - now,
        days = Math.floor(distance / day),
        hours = Math.floor((distance % day) / hour),
        minutes = Math.floor((distance % hour) / minute),
        seconds = Math.floor((distance % minute) / second);

      (wrapper.querySelector('.js-timer-days').innerText =
        (days < 10 ? '0' : '') + days),
        (wrapper.querySelector('.js-timer-hours').innerText = (
          '0' + hours
        ).slice(-2)
        ),
        (wrapper.querySelector('.js-timer-minutes').innerText = (
          '0' + minutes
        ).slice(-2)),
        (wrapper.querySelector('.js-timer-seconds').innerText = (
          '0' + seconds
        ).slice(-2));

      if (distance < 0) {
        wrapper.querySelector('.js-timer-days').innerText = '00';
        wrapper.querySelector('.js-timer-hours').innerText = '00';
        wrapper.querySelector('.js-timer-minutes').innerText = '00';
        wrapper.querySelector('.js-timer-seconds').innerText = '00';
        wrapper.style.display = 'none';
        clearInterval(interval);
      }
    }, second);

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.detail.sectionId === countdownTarget.dataset.section_id) clearInterval(interval);
    });
  }
  const countdownTargets= document.querySelectorAll(".countdown-target");
  countdownTargets.forEach(countdownTarget=>{
    window.addEventListener("DOMContentLoaded",()=>{
      const countdownEl= countdownTemplateSetup(countdownTarget);
      countdownInit(countdownEl,countdownTarget);
      //Close Button Functionality
      const button= countdownTarget.querySelector(".close-button");
      if(button != undefined){
        button.addEventListener("click",()=>{
          countdownEl.querySelector(".countdown-banner-wrapper").style.display = "none";
        })
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hero"] && !Shopify.designMode) return;
  try {
    
  const logos= document.querySelectorAll(".header__logo-image");
  if(logos.length > 0){
    function setLogoHeight(){
      const logoHeight= [...logos].reduce((prev,curr)=>{
        return prev>curr.offsetHeight ? prev : curr.offsetHeight;
      }, 0);
      document.querySelector(".index-hero-swiper").style.setProperty("--logo-height", logoHeight + "px");
    }

    setLogoHeight();
    addEventListener("resize", setLogoHeight);
  }

  const slide= document.querySelector(".index-hero-swiper .swiper-slide");
  if(slide){
    const styles= getComputedStyle(slide.children[0]);
    const pagination= document.querySelector(".index-hero-swiper .swiper-pagination");
    if(pagination){
      pagination.style.setProperty("--swiper-pagination-bottom", `${styles.paddingBottom}`);
      pagination.style.setProperty("--swiper-pagination-right", `${styles.paddingRight}`);
    }
  }

  addEventListener("DOMContentLoaded",()=>{
    const swiper = new Swiper('.index-hero-swiper', {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: true,
    })
  })

  } catch(e) { console.error(e); }
})();
})();
